/**
 * Copyright IBM Corp. 2025, 2025
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { html } from 'lit';
import { prefix } from '../../../globals/settings';

const componentName = 'full-page-error';
const blockClass = `${prefix}--${componentName}`;

export const error404SVG = html`<svg
  class=${`${blockClass}__svg ${blockClass}__404`}
  viewBox="0 0 751 549"
  fill="none"
  aria-hidden="true"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clipPath="url(#clip0_0_2285)">
    <path d="M103.296 290.22V153.267H612.488" fill="#F3F3F3" />
    <path
      d="M103.296 290.22V153.267H612.488"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M106.737 125.743H609.047C610.948 125.743 612.488 127.283 612.488 129.183V139.505H103.296V129.183C103.296 127.283 104.836 125.743 106.737 125.743Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M113.618 136.03C115.518 136.03 117.058 134.497 117.058 132.607C117.058 130.716 115.518 129.183 113.618 129.183C111.718 129.183 110.177 130.716 110.177 132.607C110.177 134.497 111.718 136.03 113.618 136.03Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M123.939 136.064C125.839 136.064 127.38 134.524 127.38 132.624C127.38 130.724 125.839 129.183 123.939 129.183C122.039 129.183 120.499 130.724 120.499 132.624C120.499 134.524 122.039 136.064 123.939 136.064Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M134.261 136.064C136.161 136.064 137.701 134.524 137.701 132.624C137.701 130.724 136.161 129.183 134.261 129.183C132.36 129.183 130.82 130.724 130.82 132.624C130.82 134.524 132.36 136.064 134.261 136.064Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M612.488 139.505H103.296V153.267H612.488V139.505Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M117.058 146.386H144.582"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M158.344 146.386H185.868"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M199.63 146.386H227.154"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M240.916 146.386H268.439"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M612.488 318.41H357.892V153.267H612.488"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M165.225 431.946L206.511 421.625L240.916 438.827L295.963 414.744L357.892 438.827V483.553"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M357.892 483.553V452.589L323.487 438.827L227.154 452.589L154.904 428.506L132.54 443.988L103.296 426.106L74.8521 449.149L36.9551 438.444L0.0817261 445.708"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M295.963 414.064L323.487 438.148"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M357.892 483.553V473.232L323.487 462.91L244.356 473.232L166.945 443.988L148.023 459.47L113.618 449.149L79.2128 473.232L41.3675 466.351H24.1651"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M132.54 443.988L148.023 459.47"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M240.916 438.827L227.154 452.589L244.356 473.232"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M587.471 180.111H474.868C467.269 180.111 461.107 186.274 461.107 193.873C461.107 201.472 467.269 207.635 474.868 207.635H523.035C526.837 207.635 529.916 210.714 529.916 214.516C529.916 218.318 526.837 221.397 523.035 221.397H416.38C410.682 221.397 406.059 226.02 406.059 231.719C406.059 237.417 410.682 242.04 416.38 242.04H605.607"
      stroke="black"
      strokeWidth="0.860121"
      strokeLinejoin="round"
    />
    <path
      d="M584.624 176.593L584.035 177.226L587.144 180.111L584.035 182.997L584.624 183.629L588.405 180.111L584.624 176.593Z"
      fill="black"
    />
    <path
      d="M622.809 180.791C617.111 180.791 612.488 185.414 612.488 191.112C612.488 185.41 607.869 180.791 602.167 180.791C607.865 180.791 612.488 176.168 612.488 170.469C612.488 176.172 617.107 180.791 622.809 180.791Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M691.619 115.422C685.921 115.422 681.298 120.045 681.298 125.743C681.298 120.04 676.679 115.422 670.976 115.422C676.674 115.422 681.298 110.798 681.298 105.1C681.298 110.803 685.916 115.422 691.619 115.422Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M616.926 48.3321C611.228 48.3321 606.605 52.9553 606.605 58.6536C606.605 52.951 601.986 48.3321 596.283 48.3321C601.982 48.3321 606.605 43.709 606.605 38.0107C606.605 43.7133 611.224 48.3321 616.926 48.3321Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M722.583 10.4868C716.885 10.4868 712.262 15.1099 712.262 20.8082C712.262 15.1056 707.643 10.4868 701.94 10.4868C707.639 10.4868 712.262 5.86362 712.262 0.165314C712.262 5.86792 716.881 10.4868 722.583 10.4868Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M239.277 201.597C236.383 201.597 233.609 202.096 231.011 202.978C225.631 189.151 212.222 179.436 196.495 179.436C177.219 179.436 161.389 194.058 159.608 212.869C156.469 211.08 152.848 210.043 148.977 210.043C137.103 210.043 127.603 219.668 127.603 231.542C127.603 243.416 137.103 253.041 148.977 253.041H239.277C253.482 253.041 264.999 241.524 264.999 227.319C264.999 213.114 253.482 201.597 239.277 201.597Z"
      stroke="black"
      strokeWidth="0.860121"
      strokeLinejoin="round"
    />
    <path
      d="M564.321 373.707C568.471 372.555 572.845 371.94 577.365 371.94C580.509 371.94 583.579 372.249 586.555 372.817C590.4 349.757 610.432 332.172 634.584 332.172C660.113 332.172 681.04 351.817 683.108 376.808C704.886 380.562 735.249 405.897 736.315 443.442"
      fill="#F3F3F3"
    />
    <path
      d="M564.321 373.707C568.471 372.555 572.845 371.94 577.365 371.94C580.509 371.94 583.579 372.249 586.555 372.817C590.4 349.757 610.432 332.172 634.584 332.172C660.113 332.172 681.04 351.817 683.108 376.808C704.886 380.562 735.249 405.897 736.315 443.442"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M612.488 325.291C616.288 325.291 619.369 322.21 619.369 318.41C619.369 314.61 616.288 311.529 612.488 311.529C608.688 311.529 605.607 314.61 605.607 318.41C605.607 322.21 608.688 325.291 612.488 325.291Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M591.639 388.794C572.368 374.817 548.663 366.577 523.04 366.577C458.436 366.577 406.063 418.95 406.063 483.553"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M492.071 414.744C512.972 414.744 529.916 397.8 529.916 376.898C529.916 355.997 512.972 339.053 492.071 339.053C471.17 339.053 454.226 355.997 454.226 376.898C454.226 397.8 471.17 414.744 492.071 414.744Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M370.334 318.574L401.087 362.827L357.643 330.938L357.806 318.41L370.334 318.574Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M357.965 305.882L402.218 275.125L370.334 318.574L357.806 318.41L357.965 305.882Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M366.665 327.269L357.806 380.429V327.269V318.41L366.665 327.269Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M366.665 309.551L419.821 318.41L366.665 327.269L357.806 318.41L366.665 309.551Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M357.806 309.551V256.391L366.665 309.551L357.806 318.41V309.551Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M357.806 242.719C361.606 242.719 364.687 239.639 364.687 235.838C364.687 232.038 361.606 228.958 357.806 228.958C354.006 228.958 350.925 232.038 350.925 235.838C350.925 239.639 354.006 242.719 357.806 242.719Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M233.686 153.267H281.763C304.565 153.267 323.049 171.751 323.049 194.553C323.049 217.355 304.565 235.839 281.763 235.839H226.715C203.913 235.839 185.429 254.323 185.429 277.124C185.429 299.926 203.913 318.41 226.715 318.41H357.892"
      fill="#F3F3F3"
    />
    <path
      d="M233.686 153.267H281.763C304.565 153.267 323.049 171.751 323.049 194.553C323.049 217.355 304.565 235.839 281.763 235.839H226.715C203.913 235.839 185.429 254.323 185.429 277.124C185.429 299.926 203.913 318.41 226.715 318.41H357.892"
      stroke="black"
      strokeWidth="0.860121"
      strokeLinejoin="round"
    />
    <path
      d="M309.725 297.763C318.984 297.763 326.489 290.061 326.489 280.561C326.489 271.06 318.984 263.358 309.725 263.358C300.467 263.358 292.961 271.06 292.961 280.561C292.961 290.061 300.467 297.763 309.725 297.763Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M302.647 280.178L309.725 287.441"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M316.808 280.178L309.725 287.441"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M309.725 287.441V318.406"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M262.212 287.777C262.509 286.943 262.668 286.048 262.668 285.111C262.668 280.698 259.09 277.12 254.678 277.12C250.265 277.12 246.687 280.698 246.687 285.111C246.687 286.044 246.846 286.943 247.143 287.777C244.429 289.975 242.692 293.333 242.692 297.096C242.692 303.715 248.059 309.082 254.678 309.082C261.296 309.082 266.663 303.715 266.663 297.096C266.663 293.333 264.926 289.975 262.212 287.777Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M249.353 291.772L254.678 297.101"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M260.006 291.772L254.678 297.101"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M254.678 297.101V318.406"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M264.001 295.767L254.678 305.091"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M245.358 295.767L254.678 305.091"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M282.201 277.12L268.439 318.406H295.963L282.201 277.12Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M282.201 290.022V318.406"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M278.073 297.763H282.201"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M282.201 304.214H286.33"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M275.32 311.955H282.201"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M420.754 545.482H681.298C686.996 545.482 691.619 540.859 691.619 535.161C691.619 529.462 686.996 524.839 681.298 524.839H591.845C580.444 524.839 571.202 515.597 571.202 504.196C571.202 492.795 580.444 483.553 591.845 483.553H729.464C740.865 483.553 750.107 474.311 750.107 462.91C750.107 451.51 740.865 442.268 729.464 442.268H492.071"
      stroke="black"
      strokeWidth="0.860121"
      strokeLinejoin="round"
    />
    <path
      d="M423.605 549L424.19 548.368L421.085 545.482L424.19 542.596L423.605 541.964L419.821 545.482L423.605 549Z"
      fill="black"
    />
    <path
      d="M516.877 418.107C517.384 411.961 522.532 407.132 528.811 407.132C534.75 407.132 539.679 411.454 540.62 417.126C541.201 417.014 541.795 416.946 542.401 416.924C544.771 408.895 552.198 403.033 560.997 403.033C563.775 403.033 566.42 403.622 568.811 404.676C572.368 400.491 577.67 397.829 583.592 397.829C584.844 397.829 586.065 397.954 587.252 398.178C588.783 388.996 596.761 381.995 606.377 381.995C616.539 381.995 624.874 389.817 625.695 399.769C634.825 401.343 647.74 412.439 646.85 428.703C646.656 432.26 646.046 436.023 642.515 442.268H507.635C504.809 439.734 503.029 436.053 503.029 431.955C503.029 424.308 509.23 418.107 516.877 418.107Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M458.01 412.421C458.01 431.232 473.26 446.482 492.071 446.482C510.882 446.482 526.132 431.232 526.132 412.421C526.132 401.321 520.82 391.46 512.598 385.242C513.995 382.296 514.778 379.001 514.778 375.522C514.778 362.982 504.611 352.815 492.071 352.815C479.53 352.815 469.364 362.982 469.364 375.522C469.364 378.997 470.142 382.296 471.544 385.242C463.321 391.46 458.01 401.321 458.01 412.421Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M475.041 401.068L492.071 415.26"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M509.101 401.068L492.071 415.26"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M492.071 415.26V545.482"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M466.525 409.583L492.071 429.452"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M517.617 409.583L492.071 429.452"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M75.7723 345.934H244.356C248.158 345.934 251.237 349.013 251.237 352.815C251.237 356.617 248.158 359.696 244.356 359.696H203.07C199.269 359.696 196.189 362.775 196.189 366.577C196.189 370.379 199.269 373.458 203.07 373.458H323.487C331.086 373.458 337.249 379.621 337.249 387.22C337.249 394.819 331.086 400.982 323.487 400.982H52.1276C29.3258 400.982 10.8418 382.498 10.8418 359.696C10.8418 336.894 29.3258 318.41 52.1276 318.41H223.713"
      fill="#F3F3F3"
    />
    <path
      d="M76.7056 345.934H244.356C248.158 345.934 251.237 349.013 251.237 352.815C251.237 356.617 248.158 359.696 244.356 359.696H203.07C199.269 359.696 196.189 362.775 196.189 366.577C196.189 370.379 199.269 373.458 203.07 373.458H323.487C331.086 373.458 337.249 379.621 337.249 387.22C337.249 394.819 331.086 400.982 323.487 400.982H52.1276C29.3258 400.982 10.8418 382.498 10.8418 359.696C10.8418 336.894 29.3258 318.41 52.1276 318.41H223.713"
      stroke="black"
      strokeWidth="0.860121"
      strokeLinejoin="round"
    />
    <path
      d="M79.5569 349.452L80.1418 348.82L77.0367 345.934L80.1418 343.048L79.5569 342.416L75.7723 345.934L79.5569 349.452Z"
      fill="black"
    />
    <path
      d="M41.3675 345.934C47.0658 345.934 51.6889 350.557 51.6889 356.255C51.6889 350.553 56.3078 345.934 62.0104 345.934C56.3121 345.934 51.6889 341.311 51.6889 335.613C51.6889 341.315 47.0701 345.934 41.3675 345.934Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M103.296 297.101C107.097 297.101 110.177 294.02 110.177 290.22C110.177 286.419 107.097 283.339 103.296 283.339C99.496 283.339 96.4153 286.419 96.4153 290.22C96.4153 294.02 99.496 297.101 103.296 297.101Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M638.317 421.534V429.09H650.045L650.123 421.543C650.127 421.066 649.74 420.674 649.262 420.674H639.178C638.704 420.674 638.317 421.061 638.317 421.534Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M651.619 434.109L650.045 429.099V426.914C650.045 425.706 649.065 424.73 647.86 424.73H645.676C643.925 424.73 643.095 425.426 642.399 426.914C641.134 428.828 638.137 429.099 638.137 429.099C633.767 433.469 626.009 433.469 626.009 440.027V442.212H652.234V437.318C652.234 436.221 652.028 435.129 651.623 434.109H651.619Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M652.234 437.842H643.491V440.027H652.234V437.842Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M689.348 421.534V429.09L677.621 429.095L677.543 421.539C677.539 421.061 677.926 420.67 678.403 420.67H688.488C688.961 420.67 689.348 421.057 689.348 421.53V421.534Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M676.042 434.109L677.616 429.099V426.914C677.616 425.706 678.597 424.73 679.801 424.73H681.986C683.736 424.73 684.566 425.426 685.263 426.914C686.527 428.828 689.525 429.099 689.525 429.099C693.894 433.469 701.652 433.469 701.652 440.027V442.212H690.725H688.54H675.427V437.318C675.427 436.221 675.634 435.129 676.038 434.109H676.042Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M675.432 440.027H684.175V437.842H675.432V440.027Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M688.484 420.674H678.399C678.399 420.674 665.489 345.685 665.334 343.913C665.334 343.913 665.334 341.307 663.829 341.307C662.323 341.307 662.323 343.913 662.323 343.913C662.173 345.685 649.262 420.674 649.262 420.674H639.177L640.674 380.636C640.799 378.898 641.874 355.989 640.661 342.64C639.384 328.62 647.03 308.592 647.03 308.592H680.631C680.631 308.592 688.277 328.62 687 342.64C685.787 355.989 686.863 378.898 686.983 380.636L688.484 420.674Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M689.662 262.588L666.68 223.182L634.503 184.231L604.304 205.377L558.124 216.206L597.526 259.367L612.144 301.384L689.662 262.588Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M604.304 205.377L634.025 240.268L655.167 280.806L612.144 301.384L597.526 259.367L558.124 216.206L604.304 205.377Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M582.237 241.937C582.801 241.528 598.184 226.992 621.597 230.218"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M623.936 244.865C621.592 239.782 621.601 232.179 621.592 230.82C621.579 227.745 622.934 222.623 624.973 219.509C635.178 203.941 654.883 207.691 654.883 207.691"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M620.736 205.498C619.653 204.048 619.945 201.993 621.399 200.905C621.726 200.66 621.997 200.483 622.366 200.376M620.693 199.967L620.113 199.193M619.266 201.778L618.38 201.399M618.939 204.061L617.98 204.177M622.831 199.116L622.715 198.157M619.79 206.203L619.016 206.784"
      stroke="black"
      strokeWidth="0.860121"
      strokeLinejoin="round"
    />
    <path
      d="M631.359 197.43C631.062 197.649 630.817 197.911 630.624 198.2C629.019 197.202 626.912 197.232 625.308 198.432C623.343 199.903 622.844 202.599 624.1 204.655C623.644 204.711 623.196 204.883 622.801 205.179C621.588 206.087 621.356 207.79 622.263 209.003C623.171 210.216 624.874 210.469 626.082 209.566L635.29 202.677C636.739 201.593 637.036 199.541 635.952 198.092C634.868 196.643 632.817 196.346 631.368 197.43H631.359Z"
      stroke="black"
      strokeWidth="0.860121"
      strokeLinejoin="round"
    />
    <path
      d="M654.458 259.186C654.458 259.186 640.175 292.305 626.375 284.848C612.148 277.159 625.88 266.889 622.371 260.124C618.844 253.333 605.783 260.963 606.648 244.466C607.422 229.671 637.677 244.633 640.971 226.076"
      stroke="black"
      strokeWidth="0.860121"
      strokeLinejoin="round"
    />
    <path
      d="M643.693 229.628L642.949 230.058L640.829 226.386L637.32 228.773L636.838 228.063L641.108 225.156L643.693 229.628Z"
      fill="black"
    />
    <path
      d="M597.526 259.367L666.68 223.182"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M641.676 222.201C642.626 222.201 643.396 221.431 643.396 220.481C643.396 219.531 642.626 218.761 641.676 218.761C640.726 218.761 639.956 219.531 639.956 220.481C639.956 221.431 640.726 222.201 641.676 222.201Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M592.516 255.733L595.036 259.427L596.58 258.292L593.802 254.791L592.516 255.733Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M590.512 252.302C590.864 252.302 591.149 252.017 591.149 251.665C591.149 251.313 590.864 251.028 590.512 251.028C590.16 251.028 589.875 251.313 589.875 251.665C589.875 252.017 590.16 252.302 590.512 252.302Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M595.806 259.819C596.336 259.819 596.765 259.389 596.765 258.86C596.765 258.33 596.336 257.901 595.806 257.901C595.276 257.901 594.847 258.33 594.847 258.86C594.847 259.389 595.276 259.819 595.806 259.819Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M593.157 256.061C593.599 256.061 593.957 255.702 593.957 255.26C593.957 254.818 593.599 254.46 593.157 254.46C592.715 254.46 592.357 254.818 592.357 255.26C592.357 255.702 592.715 256.061 593.157 256.061Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M589.996 252.043L591.024 251.286L593.802 254.791L592.516 255.733L589.996 252.043Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M668.968 262.455L681.603 288.392C682.459 290.147 684.063 291.415 685.964 291.841C690.204 292.791 694.247 289.334 693.761 285.016C692.281 271.86 680.794 254.086 680.794 254.086L668.968 262.451V262.455Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M663.717 246.28C663.717 246.28 649.469 245.347 646.932 261.281C644.863 274.277 649.258 279.481 648.888 290.465C648.712 295.707 643.874 305.328 643.874 311.615H684.747C684.747 311.615 683.598 305.057 680.274 290.465C679.41 286.667 681.388 282.134 682.906 277.09C690.135 253.075 674.993 246.28 663.717 246.28Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M644.682 306.188C644.682 306.188 636.997 321.601 636.997 346.798C647.701 351.925 663.295 350.587 663.295 350.587L663.919 346.549L664.418 350.566C664.418 350.566 679.139 353.933 690.733 347.241C691.464 321.601 683.689 306.184 683.689 306.184C683.689 306.184 669.093 311.28 644.682 306.184V306.188Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M659.717 253.243C656.917 250.757 652.049 251.583 649.069 255.165L630.013 271.8L607.68 263.896C607.68 263.896 605.71 264.093 605.121 263.612L603.143 259.096C602.971 258.67 602.687 258.301 602.326 258.021L599.836 255.97L597.513 254.064C595.999 255.462 598.378 257.247 598.623 257.453C599.608 258.262 600.193 259.565 600.193 259.565L596.421 258.124L593.514 254.89L590.813 250.934C590.624 250.637 590.228 250.547 589.931 250.736C589.635 250.925 589.544 251.321 589.733 251.617L592.168 255.742L594.602 259.866C594.658 259.956 601.887 267.56 601.887 267.56C602.317 267.912 602.339 269.117 602.339 269.117L627.635 284.926C629.088 285.833 630.955 285.717 632.284 284.633L658.083 263.62C661.446 260.447 663.42 256.529 659.726 253.247L659.717 253.243Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M651.688 231.624L653.24 231.843L654.625 238.307C655.008 240.092 656.75 241.223 658.517 240.84L660.117 240.487L664.917 239.438C669.157 243.588 667.686 252.366 667.686 252.366L685.233 248.71C681.474 244.844 676.541 235.297 678.945 225.207C680.24 222.382 680.665 219.126 679.96 215.854C678.236 207.824 670.396 202.72 662.444 204.461C654.492 206.199 649.439 214.116 651.159 222.15L651.851 225.379L650.574 229.732C650.346 230.63 650.781 231.469 651.684 231.62L651.688 231.624Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M650.518 215.673C650.518 215.673 656.087 225.01 666.542 221.866C667.222 221.664 668.25 220.528 668.108 223.431C668.06 224.442 668.452 225.513 669.135 226.545C669.071 226.898 669.032 227.259 669.015 227.624C668.77 232.63 672.567 236.888 677.5 237.142C682.433 237.391 686.63 233.538 686.88 228.532C687.082 224.468 684.613 220.898 681.044 219.565C680.932 214.314 679.134 202.801 665.751 202.431C653.55 202.096 650.522 215.673 650.522 215.673H650.518Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M667.42 229.512C668.684 229.216 669.566 228.067 669.523 226.769L669.252 222.348C669.213 221.165 668.293 219.995 667.11 220.275C666.104 220.511 665.669 221.431 666.018 223.049"
      fill="#F3F3F3"
    />
    <path
      d="M667.42 229.512C668.684 229.216 669.566 228.067 669.523 226.769L669.252 222.348C669.213 221.165 668.293 219.995 667.11 220.275C666.104 220.511 665.669 221.431 666.018 223.049"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M668.757 254.163C668.757 254.163 657.752 273.8 657.902 295.406C658.053 317.017 702.998 316.385 702.848 295.088C702.697 273.796 694.015 253.983 694.015 253.983L668.757 254.159V254.163Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M664.912 262.765L694.316 262.558C698.521 262.528 701.936 259.066 701.906 254.86C701.876 250.654 698.414 247.239 694.208 247.27L665.166 247.476C661.579 247.502 658.663 250.456 658.685 254.047L658.702 256.649C658.728 260.038 661.519 262.79 664.908 262.769L664.912 262.765Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M658.973 282.857C658.973 282.857 649.237 303.702 663.721 303.599C678.205 303.496 671.561 282.767 671.561 282.767L658.973 282.857Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M680.394 282.706C680.394 282.706 671.626 303.543 687.516 303.431C703.407 303.319 706.31 302.575 706.241 293.118C706.177 283.661 702.095 282.552 702.095 282.552L680.39 282.706H680.394Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M658.281 255.165C658.311 259.303 660.87 262.64 663.996 262.618C667.123 262.597 669.634 259.225 669.609 255.088C669.578 250.951 667.02 247.614 663.893 247.635C660.766 247.657 658.255 251.028 658.281 255.165Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M672.765 247.416C672.765 247.416 679.758 255.656 672.873 262.704L676.404 262.679C676.404 262.679 683.672 254.92 676.111 247.39L672.77 247.411L672.765 247.416Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M689.55 247.3C689.55 247.3 696.543 255.54 689.658 262.588L693.189 262.562C693.189 262.562 700.457 254.804 692.896 247.274L689.555 247.295L689.55 247.3Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M607.68 263.216L602.334 268.433"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M295.963 153.267H230.594"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M357.806 380.429V483.553H406.059"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M357.892 407.863C361.692 407.863 364.773 404.782 364.773 400.982C364.773 397.182 361.692 394.101 357.892 394.101C354.092 394.101 351.011 397.182 351.011 400.982C351.011 404.782 354.092 407.863 357.892 407.863Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M357.892 483.553H106.737"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
    <path
      d="M701.657 442.268H622.809"
      stroke="black"
      strokeWidth="0.860121"
      strokeMiterlimit="10"
    />
  </g>
  <defs>
    <clipPath id="clip0_0_2285">
      <rect
        width="750.537"
        height="548.835"
        fill="white"
        transform="translate(0 0.165344)"
      />
    </clipPath>
  </defs>
</svg>`;
